"use strict";

var _interopRequireDefault = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _regenerator2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/regenerator.js"));
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
var _user = require("@/api/user");
var _auth = require("@/utils/auth");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'Login',
  data: function data() {
    var validateUsername = function validateUsername(rule, value, callback) {
      if (!value) {
        callback(new Error('请输入账号'));
      } else {
        callback();
      }
    };
    var validatePassword = function validatePassword(rule, value, callback) {
      if (!value) {
        callback(new Error('请输入密码'));
      } else {
        callback();
      }
    };
    return {
      loginForm: {
        username: '',
        password: ''
      },
      loginRules: {
        username: [{
          required: true,
          trigger: 'blur',
          validator: validateUsername
        }],
        password: [{
          required: true,
          trigger: 'blur',
          validator: validatePassword
        }]
      },
      imgUrl: '',
      loading: false,
      passwordType: 'password',
      redirect: undefined,
      dialogVisible: false,
      appData: [],
      isAppData: false,
      // 返回
      selectApp: null,
      appStatus: 1
    };
  },
  watch: {
    $route: {
      handler: function handler(route) {
        this.redirect = route.query && route.query.redirect;
      },
      immediate: true
    }
  },
  mounted: function mounted() {},
  methods: {
    showPwd: function showPwd() {
      var _this = this;
      if (this.passwordType === 'password') {
        this.passwordType = '';
      } else {
        this.passwordType = 'password';
      }
      this.$nextTick(function () {
        _this.$refs.password.focus();
      });
    },
    handleLogin: function handleLogin() {
      var _this2 = this;
      // 本地存在 token 时走免登录，无需重新输入账号密码
      if ((0, _auth.getToken)()) {
        this.handleAutoLogin();
        return;
      }
      this.$refs.loginForm.validate(function (valid) {
        if (valid) {
          _this2.loading = true;
          _this2.$store.dispatch('user/login', _this2.loginForm).then(/*#__PURE__*/function () {
            var _ref = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee(res_login) {
              return (0, _regenerator2.default)().w(function (_context) {
                while (1) switch (_context.n) {
                  case 0:
                    _this2.loading = false;
                    // const accessRoutes = await this.$store.dispatch('permission/generateRoutes')
                    // if (accessRoutes.length > 0 && accessRoutes[0].path) {
                    //   this.$router.push({ path: accessRoutes[0].path })
                    // }
                    if (res_login === 2) {
                      // 小b端
                      _this2.dialogVisible = true;
                      _this2.queryAppUserAppRoleMapping();
                    } else {
                      localStorage.setItem('appName', '联合导购-超管后台');
                      _this2.$store.dispatch('user/set_appId', 0);
                      // this.$router.push({ path: '/systemAdministrator/creatApp/index' })
                      _this2.$router.push({
                        path: '/superTubePage'
                      });
                      // return
                      // await getInfo().then(res => {
                      //   // console.log('this.store.permission--------------', this.$store.state.permission)
                      //   // const aap = this.$store.state.permission
                      //   // console.log('this.store.permission--------------', aap.addRoutes[0].children)

                      //   // this.$router.push({ path: aap.addRoutes[0].children.path })
                      //   if (res.data.userType === 2) {
                      //     this.$router.push({ path: '/dataMarket/index' })
                      //   } else {
                      //     this.$store.dispatch('user/set_appId', 0)
                      //     // this.$router.push({ path: '/systemAdministrator/creatApp/index' })
                      //     this.$router.push({ path: '/superTubePage' })
                      //   }
                      //   // if (res.data.roles[0] === 'sys_admin') {
                      //   //   this.$router.push({ path: '/systemAdministrator/creatApp' })
                      //   // } else if (res.data.roles[0] === 'activity_admin') {
                      //   //   this.$router.push({ path: '/systemAdministrator/activityCreation/activityCreation' })
                      //   // } else if (res.data.roles[0] === 'app_admin') {
                      //   //   // this.$router.push({ path: '/member/membershipList' })
                      //   //   this.$router.push({ path: '/dataMarket/index' })
                      //   // }
                      //   this.loading = false
                      // })
                    }
                  case 1:
                    return _context.a(2);
                }
              }, _callee);
            }));
            return function (_x) {
              return _ref.apply(this, arguments);
            };
          }()).catch(function () {
            _this2.loading = false;
          });
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    // 免登录：本地已有 token，直接拉取用户信息并跳转
    handleAutoLogin: function () {
      var _handleAutoLogin = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee2() {
        var data, accessRoutes, target, _t;
        return (0, _regenerator2.default)().w(function (_context2) {
          while (1) switch (_context2.p = _context2.n) {
            case 0:
              this.loading = true;
              _context2.p = 1;
              _context2.n = 2;
              return this.$store.dispatch('user/getInfo');
            case 2:
              data = _context2.v;
              if (!(data.userType === 2)) {
                _context2.n = 6;
                break;
              }
              if (!(this.$store.getters.appId === '')) {
                _context2.n = 3;
                break;
              }
              this.dialogVisible = true;
              this.queryAppUserAppRoleMapping();
              _context2.n = 5;
              break;
            case 3:
              _context2.n = 4;
              return this.$store.dispatch('permission/generateRoutes', data.roles || []);
            case 4:
              accessRoutes = _context2.v;
              this.$router.addRoutes(accessRoutes);
              target = accessRoutes.length > 0 && accessRoutes[0].path ? accessRoutes[0].path : '/dataMarket/index';
              this.$router.push({
                path: target
              });
            case 5:
              _context2.n = 7;
              break;
            case 6:
              localStorage.setItem('appName', '联合导购-超管后台');
              this.$store.dispatch('user/set_appId', 0);
              this.$router.push({
                path: '/superTubePage'
              });
            case 7:
              _context2.n = 10;
              break;
            case 8:
              _context2.p = 8;
              _t = _context2.v;
              _context2.n = 9;
              return this.$store.dispatch('user/resetToken');
            case 9:
              this.$message.error('登录已过期，请重新登录');
            case 10:
              _context2.p = 10;
              this.loading = false;
              return _context2.f(10);
            case 11:
              return _context2.a(2);
          }
        }, _callee2, this, [[1, 8, 10, 11]]);
      }));
      function handleAutoLogin() {
        return _handleAutoLogin.apply(this, arguments);
      }
      return handleAutoLogin;
    }(),
    handleClose: function handleClose() {
      this.dialogVisible = false;
    },
    queryAppUserAppRoleMapping: function () {
      var _queryAppUserAppRoleMapping2 = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee3() {
        var _this3 = this;
        var params, res;
        return (0, _regenerator2.default)().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              params = {};
              _context3.n = 1;
              return (0, _user.queryAppUserAppRoleMapping)(params);
            case 1:
              res = _context3.v;
              console.log('res', res);
              if (res.code === 0) {
                this.appData = res.data;
                this.$nextTick(function () {
                  _this3.isAppData = true;
                });
              }
            case 2:
              return _context3.a(2);
          }
        }, _callee3, this);
      }));
      function queryAppUserAppRoleMapping() {
        return _queryAppUserAppRoleMapping2.apply(this, arguments);
      }
      return queryAppUserAppRoleMapping;
    }(),
    onSelectApp: function onSelectApp(item) {
      localStorage.setItem('appName', item.appName);
      sessionStorage.setItem('appNo', item.appNo);
      this.appStatus = item.appStatus;
      this.selectApp = item.appId;
    },
    onCancel: function () {
      var _onCancel = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee4() {
        return (0, _regenerator2.default)().w(function (_context4) {
          while (1) switch (_context4.n) {
            case 0:
              _context4.n = 1;
              return this.$store.dispatch('user/logout');
            case 1:
              this.dialogVisible = false;
              this.$router.push("/login");
            case 2:
              return _context4.a(2);
          }
        }, _callee4, this);
      }));
      function onCancel() {
        return _onCancel.apply(this, arguments);
      }
      return onCancel;
    }(),
    onVerify: function () {
      var _onVerify = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee5() {
        var _this4 = this;
        return (0, _regenerator2.default)().w(function (_context5) {
          while (1) switch (_context5.n) {
            case 0:
              if (this.selectApp) {
                _context5.n = 1;
                break;
              }
              return _context5.a(2, this.$message({
                type: 'warning',
                message: '请先选择app!'
              }));
            case 1:
              this.dialogVisible = false;
              this.$store.dispatch('user/set_appId', this.selectApp);
              _context5.n = 2;
              return (0, _user.getInfo)().then(function (res) {
                if (res.data.userType === 2) {
                  _this4.$router.push({
                    path: '/dataMarket/index'
                  });
                  sessionStorage.setItem('appStatus', _this4.appStatus);
                } else {
                  _this4.$store.dispatch('user/set_appId', 0);
                  _this4.$router.push({
                    path: '/systemAdministrator/creatApp/index'
                  });
                }
                _this4.loading = false;
              });
            case 2:
              return _context5.a(2);
          }
        }, _callee5, this);
      }));
      function onVerify() {
        return _onVerify.apply(this, arguments);
      }
      return onVerify;
    }()
  }
};